import axios from "axios"
import { headers } from "../headers";
import { baseUrl } from "../URL"

export const reinitialiserpassword = async(values)=>{
    return await axios.post(baseUrl("forgetpassword"), values, headers);
}

